import {
    faSort,
    faSortUp,
    faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IClickedHeader } from 'interfaces/ITable';

/**
 * Custom props for size table headers component
 */
interface Props {
    /**
     * The clicked header
     */
    clickedHeader: IClickedHeader;
    /**
     * The callback function to re-arrange the elements of the table 
     * based on the description of its header
     */
    orderBy: (key: string, asc: boolean) => void;
}
/**
 * The size table headers component
 */
export const TableHeaders = ({ clickedHeader, orderBy }: Props) => {
    /**
     * handles the header click and pass the header key to the parents components
     */
    const handleHeaderClick = (e: React.MouseEvent<HTMLTableCellElement>) => {
        const name = e.currentTarget.getAttribute('data-size-table-header') ?? "";
        orderBy(name, !clickedHeader.asc);
    }

    /**
     * Renders the position of the chevron based on the state of the state of the clickHeader state
     * @param asc true if order should be ascending, descending otherwise
     */
    const renderChevron = (clickedHeader: IClickedHeader) => {
        return clickedHeader.asc
            ? <FontAwesomeIcon icon={faSortUp} className="ms-2" />
            : <FontAwesomeIcon icon={faSortDown} className="ms-2" />
    }

    return (
        <thead className="bg-primary text-white">
            <tr>
                <th data-size-table-header="name" style={{ width: '30%' }} className="bg-custom-yellow text-center" onClick={(e) => handleHeaderClick(e)}>
                    Nombre
                    {clickedHeader.name === "name"
                        ? renderChevron(clickedHeader)
                        : <FontAwesomeIcon icon={faSort} className="ms-2" />
                    }
                </th>
                <th style={{ width: '30%' }} className="bg-custom-yellow text-center">
                    Distintivo
                </th>
                <th data-size-table-header="status" style={{ width: '30%' }} className="bg-custom-yellow text-center" onClick={(e) => handleHeaderClick(e)}>
                    Estado
                    {clickedHeader.name === "status"
                        ? renderChevron(clickedHeader)
                        : <FontAwesomeIcon icon={faSort} className="ms-2" />
                    }
                </th>
            </tr>
        </thead>
    )
}
